var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-table',{ref:"table",attrs:{"loadObj":{},"option":{},"colObj":{
    opId:"114",
    name:"编辑操作的具体数据",
    parentId:"LOG_ID",
    parentName:"编辑操作的具体数据",
    parentPath:"/system/editLog",
    dataClass:2,
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }